import Icon from '../components/Icon';

const CollViews = Icon(
  'coll-views',
  <>
    <path d="M4.29 9.43c6-.86 6-6 10.29-6 3.43 0 6.03 5.14 9.43 11.14H0s.04-4.54 4.29-5.14ZM0 20.57c0-2.57 2.57-4.28 6.86-4.28H18c3.7 0 6 1.34 6 2.57 0 1.71-2.57 1.71-6 1.71-6.86 0-8.57 3.43-12.86 3.43C2.57 24 0 22.95 0 20.57ZM4.29 6.86a3.43 3.43 0 1 0 0-6.86 3.43 3.43 0 0 0 0 6.86Z" />
  </>
);

export default CollViews;
